/* eslint-disable @scandipwa/scandipwa-guidelines/file-structure */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */
import ProductLabels from '../component/ProductLabels';
import { getPrice } from 'Util/Product/Extract';

const addLabelsComponent = (args, callback, instance) => {
    const { product: { sf_labels = '', price_range } = {} } = instance.props;

    const { price: { discount }} = getPrice(price_range);

    return (
        <>
            { callback(...args) }
            <ProductLabels sf_labels={ sf_labels } discount={ discount } />
        </>
    );
};

export default {
    'Component/ProductCard/Component': {
        'member-function': {
            renderPicture: addLabelsComponent
        }
    }
};
